import Vue from 'vue';
import VueRouter from 'vue-router';

// 导入TaskFlow页面组件
import Login from '../views/taskflow/Login.vue';
import Register from '../views/taskflow/Register.vue';
import TaskList from '../views/taskflow/TaskList.vue';
import Statistics from '../views/taskflow/Statistics.vue';
import UserManagement from '../views/taskflow/UserManagement.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/taskflow/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/taskflow/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/taskflow/task-list',
    name: 'TaskList',
    component: TaskList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/taskflow/statistics',
    name: 'Statistics',
    component: Statistics,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/taskflow/user-management',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      requiresAuth: true
    }
  },
  // 默认重定向到登录页面
  {
    path: '*',
    redirect: '/taskflow/login'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 路由守卫，检查登录状态
router.beforeEach((to, from, next) => {
  // 检查页面是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否有登录令牌
    const token = localStorage.getItem('token');
    if (!token) {
      // 没有登录，重定向到登录页面
      next({
        path: '/taskflow/login'
      });
    } else {
      // 已登录，继续访问
      next();
    }
  } else {
    // 不需要登录的页面，直接访问
    next();
  }
});

export default router;
